import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-per-menu-home-active-icon",
  "use": "icon-per-menu-home-active-icon-usage",
  "viewBox": "0 0 20 20.001",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20.001\" id=\"icon-per-menu-home-active-icon\"><defs><style>#icon-per-menu-home-active-icon .a{fill:none;}#icon-per-menu-home-active-icon .b{fill:#fff;}</style></defs><g transform=\"translate(-266 -150)\"><rect class=\"a\" width=\"20\" height=\"20\" transform=\"translate(266 150)\" /><path class=\"b\" d=\"M13.5,78V73h-3v5h-6V69.5a.5.5,0,0,1,1,0V77h4V72h5v5h4V69.5a.5.5,0,0,1,1,0V78Zm7.657-10.136L12,59.306,2.843,67.865a.517.517,0,0,1-.7,0,.441.441,0,0,1,0-.653L12,58l9.856,9.212a.441.441,0,0,1,0,.653.517.517,0,0,1-.7,0Zm-2.226-5.082V61H16.5a.5.5,0,0,1,0-1h3.432v2.782a.5.5,0,1,1-1,0Z\" transform=\"translate(264 92)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/per-menu-home-active-icon.svg
// module id = gmq/
// module chunks = 81